module.exports = "/images/melhor_logistica_2020.svg?d053ee7e962f7b012ebf57b9ade02527";